// TemplateList.tsx
import React from "react"
import { List } from "antd"
import { TemplateItem } from "types/template.types"

// Define the props interface for TemplateList
interface TemplateListProps {
  /** An array of template objects */
  templates: TemplateItem[]
  /** Indicates if templates are being loaded */
  listingTemplatesFromFile: boolean
  /** Callback function that is called when a template is clicked */
  onItemClick: (label: string) => void
}

/**
 * TemplateList component displays a list of templates, allowing the user to select one for further actions.
 *
 * @param props - The component props
 * @returns The rendered TemplateList component
 */
const TemplateList: React.FC<TemplateListProps> = ({
  templates,
  listingTemplatesFromFile,
  onItemClick,
}) => {
  return (
    <div className="flex flex-col space-y-2">
      <List
        itemLayout="horizontal"
        dataSource={templates}
        loading={listingTemplatesFromFile}
        renderItem={(item: TemplateItem, index: number) => (
          <List.Item
            key={index}
            className="cursor-pointer hover:bg-gray-200 rounded-md border mb-1 shadow-sm"
            onClick={() => onItemClick(item.label)}
          >
            <List.Item.Meta
              className="p-2 text-center font-semibold"
              title={item.text}
            />
          </List.Item>
        )}
      />
    </div>
  )
}

export default TemplateList
